import VModal from "@/vuetify_custom/v-modal_v1";
import { mapGetters } from "vuex";
import { VProgressLinear } from "vuetify/lib";
import { setTargetKeyNull } from "@/libs/functions_utils.js";
import VTips from "@/views/business/components/VTips.vue";
import BaseInfoModal from "./BaseInfoModal";
import DetailBaseInfo from "./DetailBaseInfo";
import Htjs from "./Htjs";
import Czxx from "./Czxx";
import XMFTList from "./XMFTList";
import { financer_mix } from "./EditMixIns";
import {
  createFKParams,
  handleParams,
  handleEditParams,
  getContractFkType,
  canGenerateAds,
} from "./utils";
// import BlogTips from '@/views/mine/components/fk_modal/BlogTips.vue'
import Tfjc from "./TFJC";
import {
  saveExpenseGroupSaveApi,
  getExpenseGroupDetailApi,
  getContractDetailApi,
  getOutsourceContractDetailApi,
  getPayeeApi,
} from "../../service";
import styles from "./index.module.less";
import moment from "moment";
export default {
  mixins: [financer_mix],
  data() {
    // this.is_period_closed = false
    return {
      // is_period_closed :false,
      show: false,
      params: createFKParams(),
      source_apply_user_arr: [],
      saving: false,
      payee_arr: [],
      payee_arr_out: [],
      getdata_loading: false,
    };
  },
  computed: {
    ...mapGetters({
      companies: "async/companies",
      companies_hash: "async/companies_hash",
      banks_hash: "async/banks_hash",
    }),
    //   show_blog_tips() {
    //     if (!this.params ||
    //       (!this.params.ads_record_ids &&
    //         !this.params.ads_vas_record_ids)
    //     ) {
    //       return false
    //     }

    //     return (!!this.params.ads_record_ids && this.params.ads_record_ids.length) ||
    //       (!!this.params.ads_vas_record_ids && this.params.ads_vas_record_ids.length)
    //   },
    cur_customer() {
      return this.$store.state.cur_customer;
    },
    is_not_operating_team() {
      // 人力、法务、行政、履约中台、商城、技术中台、战略中台、财务
      return [14, 278, 279, 280, 560, 561, 34, 9].reduce((total, item) => {
        total[item] = true;
        return total;
      }, {});
    },
  },
  watch: {
    "params.payment_purpose": {
      handler(val) {
        // console.log(val.expenses);
        if (val === "outsource") {
          this.$set(
            this.params,
            "expenses",
            this.params.expenses.map((item) => {
              return {
                ...item,
                tax_rate: "0.06",
                invoice_type: 1,
                tax: item.price ? math.eval(`${item.price} * ${0.06} / (1 + ${0.06})`).toFixed(2) : null
              }
            })
          );
        }
      },
      deep: true,
    },
  },
  created() {
    // 建立引用关系
    this.cur_customer;
    this.banks_hash;
  },
  methods: {
    // 本位币修改
    changeCnyTotalPrice() {
      this.$nextTick(() => {
        if (this.params.is_financer && this.params.currency === "CNY") {
          this.params.cny_total_price = this.params.total_price;
        }
      });
    },
    close() {
      this.show = false;
      // this.is_period_closed = false
      this.params = createFKParams();
    },
    showModal() {
      this.$nextTick(() => {
        this.resetValidation();
        this.$nextTick(() => {
          this.show = true;
        });
      });
    },
    editFromHas(expense_group, is_copy) {
      let params = handleEditParams(expense_group || {});
      //  console.log('params', params)
      params.is_cbs =
        this.banks_hash &&
        this.banks_hash[params.expense_payment_bank_id] &&
        this.banks_hash[params.expense_payment_bank_id].is_cbs;
      // expense_payment_bank_id
      // expense_payment_bank_id
      // const expense_payment = this.banks_hash[params.expense_payment_bank_id] || {}
      // params.is_yzh_cbs = (expense_payment.is_cbs || expense_payment.kingdee_settle_type === 'yzh')
      if (is_copy) {
        params = setTargetKeyNull(params, ["id"]);
        params.bfiles = [];
        params.verified_at = null;
        params.paid_at = null;
      }

      this.params = params;
      (this.params.contract_company_id = null), // 合同公司（后端不需要）
        (this.params.contract_payee_company_id = null), // 合同收款对象（后端不需要）
        (this.params.id = is_copy ? null : this.params.id);
      this.params.uid = is_copy ? null : this.params.uid;
      this.params.can_change_jy = false;
      this.params.is_jianyi = false;
      this.params.fill_user =
        is_copy || !this.params.fill_user
          ? this.cur_customer.account
          : this.params.fill_user;
      this.source_apply_user_arr = [
        {
          account: this.params.apply_user,
          id: this.params.apply_user_id,
        },
      ];
      this.params.is_financer = this.is_financer;
      const source_payee = {
        id: this.params.payee_company_account_id,
        bank: this.params.payee_bank,
        bank_account: this.params.payee_account_name,
        bank_number: this.params.payee_bank_number,
        payee_company_id: this.params.payee_company_id,
        payee_company_name: this.params.payee_company,
        text_name: `${this.params.payee_bank_number}-${this.params.payee_account_name}-${this.params.payee_bank}`,
      };
      if (is_copy) {
        this.params.verified_at = null;
        this.params.paid_at = null;
      }
      if (this.params.payment_purpose === "outsource") {
        this.payee_arr_out = [source_payee];
      } else {
        if (!this.params.payee_company || !this.params.payee_account_name) {
          getPayeeApi({
            type: "all",
            apply_user_id: this.params.apply_user_id,
            search: this.params.payee_bank_number,
          }).then((res) => {
            res = res || {};
            const accounts = res.accounts || [];
            accounts.forEach((account) => {
              if (account.id === this.params.payee_company_account_id) {
                source_payee.payee_company_name = account.payee_company_name;
                source_payee.bank_account = account.bank_account;
                this.params.payee_company = account.payee_company_name;
                this.params.payee_account_name = account.bank_account;
                this.payee_arr = [source_payee];
              }
            });
            if (!this.payee_arr || !this.payee_arr.length) {
              this.payee_arr = [source_payee];
            }
          });
          // type: 'all',
          // apply_user_id: _this.params.apply_user_id
        } else {
          this.payee_arr = [source_payee];
        }
      }
      // 合同相关信息初始化
      if (
        expense_group.outsource_contract &&
        expense_group.outsource_contract.id
      ) {
        setTimeout(() => {
          this.$nextTick(() => {
            this.$refs["2"].contractItemsChange(
              [expense_group.outsource_contract],
              false,
              "outsource_contract_id"
            );
            this.$refs["2"].changeOutsourceContract(
              expense_group.outsource_contract,
              {
                expense_group,
                need_change: !!is_copy,
                need_receipt: false,
              }
            );
          });
        }, 500);
      } else if (expense_group.contract && expense_group.contract.id) {
        setTimeout(() => {
          this.$nextTick(() => {
            this.$refs["2"].contractItemsChange(
              [expense_group.contract],
              false,
              "contract_id"
            );
            this.$refs["2"].changeContract(expense_group.contract, {
              expense_group,
              need_change: !!is_copy,
            });
          });
        }, 500);
      }
      if (!is_copy) {
        this.$set(
          this.params,
          "is_period_closed",
          !!expense_group.period_closed
        );
      }

      return this.params;
    },
    copy(data) {
      // 复制
      this.getdata_loading = true;
      getExpenseGroupDetailApi({ id: data.id })
        .then((res) => {
          this.editFromHas(res.expense_group, true);
        })
        .finally(() => {
          this.getdata_loading = false;
        });
      this.showModal();
    },
    generateFromContract(contract) {
      setTimeout(() => {
        this.generateFromContractAsync(contract);
      }, 500);
    },
    handleCreateBillFromLs(list) {
      // 银行流水生成付款单
      list = list || [];
      this.params = createFKParams();
      this.params.fill_user = this.params.apply_user = this.cur_customer.account;
      // 申请人
      this.params.apply_user_id = this.cur_customer.id;
      // this.params.team_id = this.cur_customer.root_team_id
      this.params.is_financer = this.is_financer;
      this.source_apply_user_arr = [
        {
          account: this.params.apply_user,
          id: this.params.apply_user_id,
        },
      ];
      this.payee_arr = [];
      this.payee_arr_out = [];

      const company_id = new Set();
      // const transaction_date = new Set()
      // const opposite_account_name = new Set()
      // const opposite_bank_name = new Set()
      // const opposite_bank_number = new Set()
      let bank_number = "";
      const price = list.reduce((total, item) => {
        let amount = 0;
        if (item.debit_credit_flag === "debit") {
          // 借款单
          amount += Number(item.debit_amount) || 0;
        } else {
          // 贷款单
          amount -= Number(item.credit_amount) || 0;
        }
        return total + amount;
      }, 0);
      list.forEach((item) => {
        company_id.add(item.company_id);
        //   transaction_date.add(item.transaction_date)
        //   opposite_account_name.add(item.opposite_account_name)
        //   opposite_bank_name.add(item.opposite_bank_name)
        //   opposite_bank_number.add(item.opposite_bank_number)
        bank_number = item.bank_number;
      });
      this.params.payment_type = 1;
      this.params.is_financer = this.is_financer;
      this.params.company_id = company_id.size === 1 ? company_id.get(0) : null;
      this.params.statement_item_ids = list.map((item) => item.id);
      // this.params.paid_at = transaction_date.size === 1 ? transaction_date.get(0) : ''
      // this.params.payee_account_name = opposite_account_name.size === 1 ? opposite_account_name.get(0) : ''
      // this.params.payee_bank = opposite_bank_name.size === 1 ? opposite_bank_name.get(0) : ''
      // this.params.payee_bank_number = opposite_bank_number.size === 1 ? opposite_bank_number.get(0) : ''

      for (let i = 0, len = this.companies.length; i < len; i++) {
        if (this.companies[i].id === this.params.company_id) {
          this.params.currency = this.companies[i].base_currency; // 币别
          break;
        }
      }
      /* 付款账户 */
      // this.params.payment_bank_number = bank_number
      /* 项目 相关 */
      this.params.expenses[0].name = "手动生成付款单";
      this.params.expenses[0].price = Number(price.toFixed(2));
      this.params.expenses[0].expense_teams[0].price = this.params.expenses[0].price;
      this.params.total_price = this.params.expenses[0].price;
      /* 是简易付款 */
      // this.params.is_simple = true // 线下付款
      // 反查
      // this.$util.ajax.get('/payee_company/query_account', {
      //   params: this.params
      // }).then((response) => {
      //   return response.data;
      // }).then((res) => {
      //   if (res.code === 1) {
      //     const data = res.data.payee_companies || [];
      //     for (let i = 0; i < data.length; i++) {
      //       const payee_company_accounts = data[i].payee_company_accounts
      //       for (let j = 0; j < payee_company_accounts.length; j++) {
      //         if (this.params.payee_bank_number === payee_company_accounts[j].bank_number) {
      //           this.$refs.payeeAccountSelector.setPayeeCompany(data[i], payee_company_accounts[j])
      //           return
      //         }
      //       }

      //     }
      //   } else {
      //     this.$Modal.warning({title: '错误', content: res.msg});
      //   }
      // }).catch((e) => {
      //   this.$Modal.warning({title: '错误', content: e.message});
      // })
      // 获取当前公司的付款账户信息

      this.showModal();
      if (this.params.company_id) {
        setTimeout(() => {
          this.$refs[2].getFKZH(bank_number);
        }, 500);
        //  this.$refs['2'].getFKZH()
      }
    },
    // is_out 是否是兼职外包合同
    generateFromContractAsync(contract) {
      const is_out = contract.is_out;
      this.params = createFKParams();
      // 制表人
      this.params.fill_user = this.params.apply_user = this.cur_customer.account;
      // 申请人
      this.params.apply_user_id = this.cur_customer.id;
      this.params.team_id = this.cur_customer.root_team_id;
      // this.params.company_id = this.cur_customer.company_id
      this.params.is_financer = this.is_financer;
      /* 判断是否默认简易填写 */
      this.params.can_change_jy = false;
      this.params.is_jianyi = false;
      if (
        !this.is_not_operating_team[this.cur_customer.root_team_id] &&
        !this.is_financer
      ) {
        this.params.can_change_jy = true;
        this.params.is_jianyi = true;
      }
      /* ----------------- */
      this.source_apply_user_arr = [
        {
          account: this.params.apply_user,
          id: this.params.apply_user_id,
        },
      ];
      this.payee_arr = [];
      this.payee_arr_out = [];
      this.showModal();
      this.getdata_loading = true;
      // 自动填写会计科目和分析科目
      // console.log(this.params.)
      // if (contract.analysis_title_id) {
      //   this.$set(
      //     this.params,
      //     "expenses",
      //     this.params.expenses.map((item) => ({
      //       ...item,
      //       account_title_id: contract.account_title_id,
      //       analysis_title_id: contract.analysis_title_id,
      //     }))
      //   );
      // }

      if (!is_out) {
        getContractDetailApi({ id: contract.id })
          .then((res) => {
            setTimeout(() => {
              this.$refs["2"].contractItemsChange(
                [res.contract],
                true,
                "contract_id"
              );
              this.$refs["2"].changeContract(res.contract);
            }, 500);
            this.params.payment_purpose = getContractFkType(res.contract);
          })
          .finally(() => {
            this.getdata_loading = false;
          });
      } else {
        getOutsourceContractDetailApi({ id: contract.id })
          .then((res) => {
            this.params.payment_purpose = "outsource";
            setTimeout(() => {
              this.$refs["2"].changeOutsourceContract(res.contract);
              this.$refs["2"].contractItemsChange(
                [res.contract],
                false,
                "outsource_contract_id"
              );
            }, 500);
          })
          .finally(() => {
            this.getdata_loading = false;
          });
      }
    },
    dataInit() {
      this.params = createFKParams();
      // 制表人
      this.params.fill_user = this.params.apply_user = this.cur_customer.account;
      // 申请人
      this.params.apply_user_id = this.cur_customer.id;
      this.params.team_id = this.cur_customer.root_team_id;
      this.params.is_financer = this.is_financer;
      /* 判断是否默认简易填写 */
      this.params.can_change_jy = false;
      this.params.is_jianyi = false;
      if (
        !this.is_not_operating_team[this.cur_customer.root_team_id] &&
        !this.is_financer
      ) {
        this.params.can_change_jy = true;
        this.params.is_jianyi = true;
      }
      /* ----------------- */
      this.source_apply_user_arr = [
        {
          account: this.params.apply_user,
          id: this.params.apply_user_id,
        },
      ];
      this.payee_arr = [];
      this.payee_arr_out = [];
      this.showModal();
    },
    // 从投放记录跳过来生成付款单
    generateFromBlog(data) {
      data = data || {};
      this.dataInit();
      let contract = null;
      if (data.ads_record_ids && data.ads_record_ids.length) {
        this.params.tfjc_type = 0;
        this.params.placing_ads_records = data.ads_record_ids.map((i) => ({
          ...i,
          have_paid_amount:
            Number(i.payable_price) ||
            Number(i.total_price) - Number(i.paid_price) ||
            0,
        }));
        this.params.placing_ads_records.forEach((i) => {
          contract = i.placing_ads_contract;
        });
      } else if (data.ads_vas_record_ids && data.ads_vas_record_ids.length) {
        this.params.tfjc_type = 0;
        this.params.placing_ads_vas_records = data.ads_vas_record_ids;
        this.params.placing_ads_vas_records.forEach((i) => {
          contract = i.placing_ads_contract;
        });
      }

      if (contract) {
        switch (contract.contract_type) {
          case "OutsourceContract":
            getOutsourceContractDetailApi({ id: contract.contract_id })
              .then((res) => {
                this.params.payment_purpose = "outsource";
                setTimeout(() => {
                  // fix: 博主信息采集匹配科目
                  this.$refs["2"].changeOutsourceContract(res.contract);
                  this.$refs["2"].contractItemsChange(
                    [res.contract],
                    false,
                    "outsource_contract_id"
                  );
                }, 500);
              })
              .finally(() => {
                this.getdata_loading = false;
              });
            break;

          default:
            getContractDetailApi({ id: contract.contract_id })
              .then((res) => {
                setTimeout(() => {
                  this.$refs["2"].contractItemsChange(
                    [res.contract],
                    true,
                    "contract_id"
                  );
                  this.$refs["2"].changeContract(res.contract, {
                    need_change: false,
                  });
                }, 500);
                this.params.payment_purpose = getContractFkType(res.contract);
              })
              .finally(() => {
                this.getdata_loading = false;
              });
            break;
        }
      }
    },
    edit(data) {
      // 编辑
      // this.is_period_closed = false
      if (data && data.id) {
        this.getdata_loading = true;
        getExpenseGroupDetailApi({ id: data.id })
          .then((res) => {
            this.editFromHas(res.expense_group);
            // this.is_period_closed = res.expense_group.period_closed
          })
          .finally(() => {
            this.getdata_loading = false;
          });
        this.showModal();
      } else if (data && !data.id) {
        this.editFromHas(data, true);
        this.showModal();
      } else {
        this.dataInit();
      }
    },
    validate() {
      let go = true;
      for (let i = 1; i <= 6; i++) {
        if (this.$refs[i] && !this.$refs[i].validate()) {
          go = false;
        }
      }
      return go;
    },
    resetValidation() {
      for (let i = 1; i <= 5; i++) {
        this.$refs[i] &&
          this.$refs[i].resetValidation &&
          !this.$refs[i].resetValidation();
      }
    },
    submitProxy() {
      // if (this.is_period_closed) {
      //     this.$vModal.confirm({
      //       title:'提示',
      //       content: '当前账期已关闭，编辑过程只有“备注”字段可修改生效，其他字段信息修改无效，请知悉~',
      //       onOk:() => {
      //         this.submit()
      //       }
      //     })
      //     return
      //   }
      this.submit();
    },
    postData(params) {
      this.saving = true;
      saveExpenseGroupSaveApi(params)
        .then(() => {
          this.$Message.success({
            content: "操作成功!",
          });
          this.close();
          this.$emit("success");
        })
        .finally(() => {
          this.saving = false;
        });
    },
    submit() {
      setTimeout(() => {
        // let params = JSON.parse(JSON.stringify(this.params))
        //  params = handleParams(params)
        // const _params = handleParams(this._params)
        if (this.validate()) {
          let params = JSON.parse(JSON.stringify(this.params));
          params.placing_ads_records = params.placing_ads_records || [];
          /* -------------------------判断该付款单是否必须关联投放记录--------------------*/
          const { contract_nature, is_recharge, contract_type = {} } =
            params.contract_source || {};
          // if (params.contract_id && // 非兼职外包合同
          //     contract_nature === 'close' && // 闭口合同
          //     !is_recharge && // 非充值合同
          //     contract_type.sub_type === '广告合同' && // 广告合同
          //     (Number(this.params.tfjc_type) === 0 && !params.placing_ads_records.filter(i => !!i.id).length) // 没有投放记录
          //     ) {
          //         this.$vModal.warning({
          //             title:'提示',
          //             content: '合同为闭口合同、广告合同、非充值时，必须关联投放记录！'
          //         })
          //         return
          //     }
          params = handleParams(params);
          /* ------------------------------------------------------------------------*/
          /* -------------------------判断关联投放记录是否在同一个月--------------------*/
          const month_set = new Set([]);
          if (params.placing_ads_records) {
            params.placing_ads_records.forEach((i) => {
              month_set.add(moment(i.service_date).format("YYYY-MM"));
            });
          }

          if (month_set.size > 1) {
            this.$vModal.confirm({
              title: "提示",
              content: "申请付款的投放记录的发布时间不在同一个月，是否继续？",
              onOk: () => this.postData(params),
            });
            return;
          }
          /* ------------------------------------------------------------------------*/

          /* --------------------------判断是否需要提交expense_spus------------------------------------- */
          if (params.expenses && Array.isArray(params.expenses)) {
            for (const expense of params.expenses) {
              if (expense.expense_spus && Array.isArray(expense.expense_spus) && expense.expense_spus.length > 0 && !expense.expense_spus[0].cya_spu_id) {
                delete expense.expense_spus
              }
            }
          }
          /* ----------------------------------------------------------------------- */
          this.postData(params);
        } else {
          this.$Message.error({
            content:
              "存在未通过校验，请仔细阅读字段下的提示语，按照提示语填写后才可保存!",
          });
        }
      }, 200);
    },
  },
  render() {
    const _this = this;
    return (
      <VModal
        fullscreen
        v-model={_this.show}
        title={_this.params.id ? "编辑付款申请" : "新建付款申请"}
        loading={_this.saving}
        width={600}
        ref="modal"
        ok-text="保存"
        on={{
          ok: () => {
            this.submitProxy();
          },
          cancel: () => {
            this.close();
          },
        }}
      >
        {_this.getdata_loading && (
          <VProgressLinear indeterminate color="primary" />
        )}
        <div class={styles["form-contain"]}>
          <div class={styles["fixed-tip"]}>
            <VTips>
              <div>
                <a
                  href="https://shimo.im/docs/wDp9JhwaPAY3ndyM"
                  target="__blank"
                >
                  合同与付款流程操作指南
                </a>
              </div>
            </VTips>
          </div>

          <BaseInfoModal
            ref="1"
            defaultApply={this.source_apply_user_arr}
            v-model={_this.params}
          />
          <hr />
          <DetailBaseInfo
            ref="2"
            defaultPayee={this.payee_arr}
            defaultPayeeOut={this.payee_arr_out}
            v-model={_this.params}
            on={{
              changeCurrency: () => {
                _this.changeCnyTotalPrice();
              },
              setDefaultPayeeOut: (item) => {
                if (!item || !item.id) {
                  return;
                }
                const ids = this.payee_arr_out.map((i) => i.id);
                if (!ids.includes(item.id)) {
                  this.payee_arr_out.push(item);
                }
              },
            }}
          />

          <hr />
          {_this.params.expense_group_settlements &&
            !!_this.params.expense_group_settlements.length && (
              <div>
                <Htjs ref="3" v-model={_this.params} />
                <hr />
              </div>
            )}
          {
            <Tfjc
              ref="6"
              showCalculate
              refresh={this.show}
              v-model={_this.params}
              havePaidAmountitle="本次付款金额"
              havePaidAmountitleTotal="本次付款金额总计："
            />
          }
          <hr />
          {_this.params.is_recharge && <Czxx ref="4" v-model={_this.params} />}
          {!_this.params.is_jianyi && (
            <XMFTList
              ref="5"
              v-model={_this.params}
              on={{
                changePrice: (val) => {
                  //
                  _this.params.total_price = val;
                  _this.changeCnyTotalPrice();
                },
              }}
            />
          )}
        </div>
      </VModal>
    );
  },
};
